import {
  ApiGetStakingRiskProducts,
  ApiCreateStakingRiskProductByID,
  ApiGetStakingRiskProductsUserInfo,
  ApiDeleteStakingRiskProductsUserInfo,
  ApiGetStakingRiskProductUserInfo,
  ApiPutStakingRiskProductUserInfo,
  ApiStakingPortfolioRisk,
  ApiUpdateStakingRiskAlert,
  ApiGetStakingRiskGeneral,
  ApiGetStakingRiskProductsUserInfoWithNoSelected,
} from "../Api";
import {
  CREATE_STAKING_RISK_PRODUCT_BYID_FOR_USER,
  CREATE_STAKING_RISK_PRODUCT_BYID_ERROR,
  DELETE_STAKING_RISK_PRODUCT_BYID_FOR_USER,
  GET_STAKING_RISK_PRODUCT_USERINFO,
  STAKING_RISK_PRODUCTS_LIST,
  STAKING_RISK_PRODUCTS_LIST_USER_INFO,
  UPDATE_STAKING_RISK_PRODUCT_USERINFO,
  STAKING_PORTFOLIO_RISK,
  UPDETE_STAKINGRISK_ALERT_SUCCESS,
  STAKING_RISK_INVESTMENT_RISK_ALERT,
  STAKING_RISK_PRODUCTS_LIST_USER_INFO_WITH_NO_SELECTED,
  CREATE_STAKING_RISK_PRODUCT_LOADING,
} from "../Reducer/StakingRiskReducer";

export function StakingRiskProductsThunk() {
  return (dispatch) => {
    ApiGetStakingRiskProducts().then((result) => {
      dispatch({
        type: STAKING_RISK_PRODUCTS_LIST,
        payload: {
          data: result?.data?.data,
        },
      });
    });
  };
}
export function GetStakingRiskProductsUserInfoThunk(data) {
  return (dispatch) => {
    ApiGetStakingRiskProductsUserInfo(data).then((result) => {
      dispatch({
        type: STAKING_RISK_PRODUCTS_LIST_USER_INFO,
        payload: {
          data: result?.data?.data,
        },
      });
    });
  };
}
export function GetStakingRiskProductsUserInfoWithNoSelectedThunk(data) {
  return (dispatch) => {
    ApiGetStakingRiskProductsUserInfoWithNoSelected(data).then((result) => {
      dispatch({
        type: STAKING_RISK_PRODUCTS_LIST_USER_INFO_WITH_NO_SELECTED,
        payload: {
          data: result?.data?.data,
        },
      });
    });
  };
}
export function CreateStakingRiskProductByIDThunk(id, amount) {
  return async (dispatch) => {
    dispatch({ type: CREATE_STAKING_RISK_PRODUCT_LOADING });
    try {
      await ApiCreateStakingRiskProductByID(id, amount);
      dispatch({
        type: CREATE_STAKING_RISK_PRODUCT_BYID_FOR_USER,
      });
    } catch (error) {
      dispatch({
        type: CREATE_STAKING_RISK_PRODUCT_BYID_ERROR,
        payload: error?.response?.data || {
          message: "An unknown error occurred.",
        },
      });
    }
  };
}

export function DeleteStakingRiskProductsUserInfoThunk(id) {
  return (dispatch) => {
    ApiDeleteStakingRiskProductsUserInfo(id).then((result) => {
      dispatch({
        type: DELETE_STAKING_RISK_PRODUCT_BYID_FOR_USER,
        payload: {
          data: result?.data?.data,
        },
      });
    });
  };
}

export function GetStakingRiskProductUserInfoThunk(id) {
  return (dispatch) => {
    ApiGetStakingRiskProductUserInfo(id).then((result) => {
      dispatch({
        type: GET_STAKING_RISK_PRODUCT_USERINFO,
        payload: {
          data: result?.data?.data,
        },
      });
    });
  };
}

export function UpdateStakingRiskProductUserInfoThunk(id, alert, amount) {
  return (dispatch) => {
    ApiPutStakingRiskProductUserInfo(id, alert, amount).then((result) => {
      dispatch({
        type: UPDATE_STAKING_RISK_PRODUCT_USERINFO,
        payload: {
          data: result?.data?.data,
        },
      });
    });
  };
}

export function StakingPortfolioRiskThunk() {
  return (dispatch, getState) => {
    ApiStakingPortfolioRisk().then((result) => {
      dispatch({
        type: STAKING_PORTFOLIO_RISK,
        payload: {
          result: result.data.data,
        },
      });
    });
  };
}

export function UpdateStakingRiskInvestmentAlertThunk(alert, type) {
  return (dispatch, getState) => {
    ApiUpdateStakingRiskAlert(alert, type)
      .then((result) => {
        return dispatch({
          type: UPDETE_STAKINGRISK_ALERT_SUCCESS,
        });
      })
      .catch((error) => {});
  };
}

export function StakingRiskRiskAlertThunk() {
  return (dispatch, getState) => {
    ApiGetStakingRiskGeneral().then((result) => {
      dispatch({
        type: STAKING_RISK_INVESTMENT_RISK_ALERT,
        payload: {
          result: result.data.data,
        },
      });
    });
  };
}
